import { render, staticRenderFns } from "./HorarioDescarga.vue?vue&type=template&id=304dac8e&"
import script from "./HorarioDescarga.vue?vue&type=script&lang=js&"
export * from "./HorarioDescarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports